import axios from 'axios';
import { getAPIHost } from '../../utils';

const uploadFile = (formData) =>
    new Promise((resolve, reject) => {
        axios
            .post(`${getAPIHost()}/file-upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                resolve(response);
            })
            .catch(() => {
                reject(new Error('Unable to upload file'));
            });
    });

export default uploadFile;
